define('bizzabo/views/main/analytics/TopEntitiesTabbedView',[
    'jquery',
    'backbone',
    'underscore',
    'bizzabo/models/Global',
    'bizzabo/bzapi',
    'bizzabo/utils',
    'bizzabo/config',
    'bizzabo/consts',
    'bizzabo/models/Session',
    'bizzabo/models/Person',
    'bizzabo/models/Speaker',
    'bizzabo/models/Partner',
    'bizzabo/models/TopEntities',
    'hbars!bizzabo/templates/sessionsTopEntitiesItemView',
    'hbars!bizzabo/templates/personsTopEntitiesItemView',
    'hbars!bizzabo/templates/speakersTopEntitiesItemView',
    'hbars!bizzabo/templates/partnersTopEntitiesItemView',
    'hbars!bizzabo/templates/topEntitiesTabbedView',
    'hbars!bizzabo/templates/topEntitiesView'
], function(
    $,
    Backbone,
    _,
    Global,
    BZAPI,
    UTILS,
    CONFIG,
    Consts,
    Session,
    Person,
    Speaker,
    Partner,
    TopEntities,
    SessionsTopEntitiesItemView,
    PersonsTopEntitiesItemView,
    SpeakersTopEntitiesItemView,
    PartnersTopEntitiesItemView,
    topEntitiesTabbedViewTemplate,
    topEntitiesViewTemplate
    ) {

    var templates = {
        'session': SessionsTopEntitiesItemView,
        'person': PersonsTopEntitiesItemView,
        'speaker': SpeakersTopEntitiesItemView,
        'partner': PartnersTopEntitiesItemView
    };

    var TopEntitiesTabbedView = Backbone.View.extend({

        entities : {
            'session' : {
                entityName : 'session',
                entityNameAttribute : 'sessions',
                model : Session,
                headers : ['Views', 'Added To Calendar', 'Likes'],
                sort : 'view'
            },
            'person' : {
                entityName : 'person',
                entityNameAttribute : 'persons',
                model : Person,
                headers : ['Views', 'Mark as lead'],
                sort : 'view'
            },
            'speaker' : {
                entityName : 'speaker',
                entityNameAttribute : 'speakers',
                model : Speaker,
                headers : ['Views', 'Likes'],
                sort : 'view'
            },
            'sponsor' : {
                entityName : 'partner',
                entityNameAttribute : 'sponsors',
                model : Partner,
                headers : ['Views', 'Likes', 'Actions'],
                sort : 'view'
            },
            'exhibitor' : {
                entityName : 'partner',
                entityNameAttribute : 'exhibitors',
                model : Partner,
                headers : ['Views', 'Likes', 'Actions'],
                sort : 'view'
            }
        },

        events : {
            'click li a' : 'switchViewClicked'
        },

        remove : function() {
            this.removeSubView();
            this.$el.remove();
            this.stopListening();
            return this;
        },

        removeSubView : function() {
            this.subView && this.subView.remove();
            this.subView = undefined;
        },

        setSubView : function(view) {
            this.removeSubView();
            this.subView = view;
            this.$('.selectedView').html(this.subView.render().el);
        },

        switchView : function(entityName) {
            var listConfig = this.entities[entityName];
            var list = new TopEntities();
            list.eventId = this.model.id;
            list.model = listConfig.model;
            list.entityName = listConfig.entityName;
            list.entityNameAttribute = listConfig.entityNameAttribute;
            list.sortAttribute = listConfig.sort;

            this.setSubView(new TopEntitiesView({
                model : list,
                headers : listConfig.headers,
                mockData : this.mockData
            }));
            this.$('li.selected').removeClass('selected');
            this.$('li.' + entityName).addClass('selected');
            this.mockData && this.showMockData(entityName);
        },

        switchViewClicked : function(e) {
            var currentName = this.$('li.selected').attr('class').replace(' selected', '');
            var entityName = $(e.target).attr('name');
            if (currentName != entityName) {
                this.switchView(entityName);
            }
        },

        showMockData : function(entityName) {
            var data = {
                person: [
                    {
                        'first-name' : "Jordan",
                        'last-name' : "Kratz",
                        'title' : "Partner",
                        'company' : "Mobile Foundation",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/bkw0ojj0jsarm77indvq.jpg",
                        "markers-data-views": 151,
                        "markers-data-highlights": 58
                    },
                    {
                        'first-name' : "Rudolph",
                        'last-name' : "Pansky",
                        'title' : "Partnerships Director",
                        'photo-set-small' : "https://cloudinary-a.akamaihd.net/bizzabo/image/upload/w_270,h_270,c_fill,g_face/ds8zcklwiijylxcqzvmt.jpg",
                        "markers-data-views": 145,
                        "markers-data-highlights": 47
                    },
                    {
                        'first-name' : "Cherilyn",
                        'last-name' : "Bauer",
                        'title' : "UX/UI Designer",
                        'company' : "Solido Studio",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/x1kr0lj7erasdxbu8wxn.jpg",
                        "markers-data-views": 130,
                        "markers-data-highlights": 25
                    },
                    {
                        'first-name' : "Jason",
                        'last-name' : "Lopac",
                        'title' : "CEO",
                        'company' : "Happiest Studios",
                        'photo-set-small' : "https://cloudinary-a.akamaihd.net/bizzabo/image/upload/w_270,h_270,c_fill,g_face/hhxb1qmhro83qj3khqpd.jpg",
                        "markers-data-views": 115,
                        "markers-data-highlights": 24
                    },
                    {
                        'first-name' : "Toung",
                        'last-name' : "Montgomery",
                        'title' : "CEO",
                        'company' : "The T100",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/za6vimcqksoqmd1ytov4.png",
                        "markers-data-views": 107,
                        "markers-data-highlights": 20
                    }
                ],
                speaker: [
                    {
                        'first-name' : "Yung",
                        'last-name' : "Jake",
                        'title' : "Musician",
                        'company' : "Capital Records",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/ynontbez8tocpxlv9laa.png",
                        "markers-data-views": 412,
                        "markers-data-likes": 85
                    },
                    {
                        'first-name' : "Yoni",
                        'last-name' : "Nevo",
                        'title' : "CEO and Founder",
                        'company': 'Cimagine',
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/nqn91l6bysprk3o5sfie.png",
                        "markers-data-views": 325,
                        "markers-data-likes": 77
                    },
                    {
                        'first-name' : "Valerie",
                        'last-name' : "Cottereau",
                        'title' : "Head Evangelist",
                        'company' : "Artefacto",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/elb1vqw18ukn3r0xgyui.png",
                        "markers-data-views": 308,
                        "markers-data-likes": 75
                    },
                    {
                        'first-name' : "Charles",
                        'last-name' : "Lord",
                        'title' : "Global Communications Chief",
                        'company' : "Waze",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/wcqhl5pkc4y1sp07lphw.png",
                        "markers-data-views": 220,
                        "markers-data-likes": 54
                    },
                    {
                        'first-name' : "Wedge",
                        'last-name' : "Martin",
                        'title' : "CTO and Co-Founder",
                        'company' : "Arqetype",
                        'photo-set-small' : "https://res.cloudinary.com/bizzaboprod/image/upload/w_270,h_270,c_fill,g_face/ekbbjarqiylxytsvaul6.png",
                        "markers-data-views": 198,
                        "markers-data-likes": 39
                    }
                ],
                session: [
                    {
                        name: 'Hello',
                        'markers-data-views': 656,
                        'markers-data-add-to-cal': 250,
                        'markers-data-likes': 287
                    },
                    {
                        name: 'Hello',
                        'markers-data-views': 560,
                        'markers-data-add-to-cal': 234,
                        'markers-data-likes': 257
                    },
                    {
                        name: 'Hello',
                        'markers-data-views': 502,
                        'markers-data-add-to-cal': 198,
                        'markers-data-likes': 234
                    },
                    {
                        name: 'Hello',
                        'markers-data-views': 427,
                        'markers-data-add-to-cal': 187,
                        'markers-data-likes': 233
                    },
                    {
                        name: 'Hello',
                        'markers-data-views': 342,
                        'markers-data-add-to-cal': 152,
                        'markers-data-likes': 98
                    }
                ],
                sponsor: [
                    {
                        'company-name': 'Microsoft',
                        'logo-set-small': 'https://crunchbase-production-res.cloudinary.com/image/upload/c_pad,h_98,w_98/v1397182206/6835990abacfb4d14ecdbfc87641e469.jpg',
                        'markers-data-views': 489,
                        'markers-data-likes': 79,
                        'markers-data-actions': 56
                    },
                    {
                        'company-name': 'Yammer',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/jyvg2t2dz6tvwzfjgjvr.png',
                        'markers-data-views': 325,
                        'markers-data-likes': 76,
                        'markers-data-actions': 43
                    },
                    {
                        'company-name': 'Mailchimp',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/m7jr2nbzao0zqo1p7efd.png',
                        'markers-data-views': 245,
                        'markers-data-likes': 74,
                        'markers-data-actions': 29
                    },
                    {
                        'company-name': 'Sequoia Capital',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/cb8yae7uiynzfweaamky.png',
                        'markers-data-views': 212,
                        'markers-data-likes': 54,
                        'markers-data-actions': 25
                    },
                    {
                        'company-name': 'Instaradio',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/nb2shetfkdp5ycedj2pk.png',
                        'markers-data-views': 176,
                        'markers-data-likes': 51,
                        'markers-data-actions': 12
                    }
                ],
                exhibitor: [
                    {
                        'company-name': 'DYN',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/l0bnapjmg6fu8irtqw7h.png',
                        'markers-data-views': 225,
                        'markers-data-likes': 54,
                        'markers-data-actions': 77
                    },
                    {
                        'company-name': 'SOMA',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/ioqtqhrxfcbaq32zomye.png',
                        'markers-data-views': 127,
                        'markers-data-likes': 52,
                        'markers-data-actions': 65
                    },
                    {
                        'company-name': 'Microsoft Ventures',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/gikrllbfwvioawhlfpkd.png',
                        'markers-data-views': 124,
                        'markers-data-likes': 46,
                        'markers-data-actions': 60
                    },
                    {
                        'company-name': 'Source Bits',
                        'logo-set-small': 'https://res.cloudinary.com/bizzaboprod/image/upload/w_200,h_120,c_fit/aarw8k5zvmihnh2nlwlr.png',
                        'markers-data-views': 106,
                        'markers-data-likes': 34,
                        'markers-data-actions': 51
                    },
                    {
                        'company-name': 'Microsoft',
                        'logo-set-small': 'https://crunchbase-production-res.cloudinary.com/image/upload/c_pad,h_98,w_98/v1397182206/6835990abacfb4d14ecdbfc87641e469.jpg',
                        'markers-data-views': 103,
                        'markers-data-likes': 32,
                        'markers-data-actions': 24
                    }
                ]
            }[entityName];
            this.subView.model.reset(data);
        },

        render : function() {
            var html = topEntitiesTabbedViewTemplate({});
            this.$el.html(html);

            if (!this.subView) {
                this.switchView('person');
            }
            return this;
        }

    });

    var TopEntitiesView = Backbone.View.extend({

        className : 'topEntitiesTabbedView-table-wrapper',

        events : {
            'click .see-all' : 'seeAllClicked'
        },

        initialize : function() {
            this.subViews = [];
            this.listenTo(this.model, 'reset', this.render);
            this.listenTo(this.model, 'add', this.addSubView);
            this.stateModel = new Backbone.Model({
                loading : true,
                headers : this.options.headers,
                entityName : this.model.entityName,
                noResults : false,
                hasPaging : false,
                seeAll : true
            });
            this.listenTo(this.stateModel, 'change:loading', this.renderLoading);
            this.listenTo(this.stateModel, 'change:noResults', this.renderNoResults);
            this.listenTo(this.stateModel, 'change:hasPaging', this.renderSeeAll);
            this.listenTo(this.stateModel, 'change:seeAll', this.renderSeeAll);
            this.fetchModel();
            this.addScrollListener();
        },

        remove : function() {
            this.removeSubViews();
            this.removeScrollListener();
            this.$el.remove();
            this.stopListening();
            return this;
        },

        fetchModel : function() {
            if (this.options.mockData) {
                this.stateModel.set('loading', false);
                return;
            }

            var previousLength = this.model.length;
            this.stateModel.set('loading', true);
            this.stateModel.set('hasPaging', false);
            var thisView = this;
            var done = function(model) {
                thisView.stateModel.set('loading', false);
                thisView.stateModel.set('noResults', (thisView.model.length <= 0));
                thisView.stateModel.set('hasPaging', (model.length > previousLength) && (model.length % model.defaultCount == 0));
            };
            this.model.fetch({
                update : true,
                remove : false,
                success : done,
                error : done
            });
        },

        addScrollListener : function() {
            var thisView = this;
            this.$el.bind('scroll', function() {
                if ($(this).scrollTop() + $(this).innerHeight() >= $(this)[0].scrollHeight) {
                    thisView.stateModel.get('hasPaging') && thisView.fetchModel();
                }
            });
        },

        removeScrollListener : function() {
            this.$el.unbind('scroll');
        },

        seeAllClicked : function() {
            this.stateModel.set('seeAll', false);
            this.fetchModel();
        },

        addSubView : function(model) {
            var subView = new TopEntitiesItemView({
                model : model
            });
            model.entityName = this.model.entityName;
            model.set('position', this.subViews.length + 1);
            this.$('tbody').append(subView.render().$el);
            this.subViews.push(subView);
        },

        removeSubViews : function() {
            _.chain(this.subViews).invoke('remove');
            this.subViews = [];
        },

        renderNoResults : function() {
            this.$('.no-results').toggleClass('hide', !this.stateModel.get('noResults'));
        },

        renderLoading : function() {
            this.$('.loading').toggleClass('hide', !this.stateModel.get('loading'));
        },

        renderSeeAll : function() {
            this.$('.see-all').toggleClass('hide', !this.stateModel.get('seeAll') || !this.stateModel.get('hasPaging'));
        },

        render : function() {
            this.removeSubViews();

            var html = topEntitiesViewTemplate(this.stateModel.toJSON());
            this.$el.html(html);

            for (var i = 0; i < this.model.length; i++) {
                this.addSubView(this.model.at(i));
            }
            return this;
        }

    });

    var TopEntitiesItemView = Backbone.View.extend({

        tagName : 'tr',

        render : function() {
            var template = templates[this.model.entityName];
            var html = template(this.model.toJSON());
            this.$el.html(html);
            return this;
        }

    });

    return TopEntitiesTabbedView;

});
